import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { RequirementDiv, IconPass, IconFail } from './styledComponents';

const containsAtLeast8Chars = (str) => {
  return str.length >= 8;
};
const containsThreeIdenticalInRow = (str) => {
  return /(.)\1\1/.test(str);
};
const containsUppercase = (str) => {
  return /[A-Z]/.test(str);
};
const containsLowercase = (str) => {
  return /[a-z]/.test(str);
};
const containsDigit = (str) => {
  return /\d/.test(str);
};
const containsSpecialChar = (str) => {
  return /[^A-Za-z0-9]/.test(str);
};
const validMultipleRequirements = (str) => {
  let types = 0;
  if (containsUppercase(str)) types += 1;
  if (containsLowercase(str)) types += 1;
  if (containsDigit(str)) types += 1;
  if (containsSpecialChar(str)) types += 1;
  return types >= 3;
};
const validPassword = (password) => {
  return (
    containsAtLeast8Chars(password) &&
    validMultipleRequirements(password) &&
    !containsThreeIdenticalInRow(password)
  );
};

const RequirementIcon = ({ pass }) => {
  return pass ? <IconPass /> : <IconFail />;
};

RequirementIcon.propTypes = {
  pass: PropTypes.bool.isRequired,
};

function PasswordRequirements({ password, onValidate }) {
  useEffect(() => {
    onValidate(validPassword(password));
  }, [password, onValidate]);

  const notContainsThreePass =
    !containsThreeIdenticalInRow(password) && password !== '';

  return (
    <div style={{ margin: '5px 0 20px' }}>
      <RequirementDiv>
        <RequirementIcon pass={containsAtLeast8Chars(password)} />
        Contain at least 8 characters
      </RequirementDiv>
      <RequirementDiv>
        <RequirementIcon pass={validMultipleRequirements(password)} />
        Contain at least three of the following: uppercase letters, lowercase
        letters, digits, and special characters
      </RequirementDiv>
      <RequirementDiv>
        <RequirementIcon pass={notContainsThreePass} />
        Not contain more than two identical characters in a row
      </RequirementDiv>
    </div>
  );
}

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default PasswordRequirements;
